export default __webpack_public_path__ + "static/media/admin_users.50397ce7.svg";